/* eslint-disable no-shadow */
import React, { Fragment } from 'react';
import cn from 'classnames';
import { HiOutlineX } from 'react-icons/hi';
import {
  // BiDownload,
  // BiFile,
  BiListUl,
  BiLockOpen,
  // BiMoney,
  BiStore,
  BiTable,
} from 'react-icons/bi';
import AuthStore from 'auth-store';
import { RiDashboardLine } from 'react-icons/ri';
// import { CgDatabase } from 'react-icons/cg';
import PropTypes from 'prop-types';
import { Link, NavLink } from 'react-router-dom';
import logo from 'assets/images/logo-horizontal-white.png';
import { SolidLogo } from 'modules/common/components/AppIconLogo';
import { Dialog, Transition } from '@headlessui/react';
// import AccountSidebarStatus from 'core-modules/profile/components/AccountSidebarStatus';
// import AccountSwitcher from 'modules/auth/components/AccountSwitcher';
import { useActiveAccount } from 'modules/auth/hooks';
// import SidebarProfile from './SidebarProfile';

const NavItem = ({ label, icon: Icon, to }) => {
  return (
    <NavLink
      to={to}
      className={cn('sidenav-link group')}
      activeClassName="active"
    >
      <Icon className="icon" aria-hidden="true" />
      <span>{label}</span>
    </NavLink>
  );
};

NavItem.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.instanceOf(Object).isRequired,
  to: PropTypes.string.isRequired,
};

const NavSubItem = ({ label, icon: Icon, to }) => {
  return (
    <NavLink to={to} className="sidenav-sublink group" activeClassName="active">
      {Icon && (
        <Icon className="icon group-hover:text-gray-500" aria-hidden="true" />
      )}
      <span>{label}</span>
    </NavLink>
  );
};

NavSubItem.defaultProps = {
  icon: false,
};

NavSubItem.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.bool]),
  to: PropTypes.string.isRequired,
};

const NavGroup = ({ label, children }) => (
  <div className="">
    {label && (
      <h3 className="px-3 py-2 text-xs font-semibold text-gray-500 uppercase tracking-wider">
        {label}
      </h3>
    )}
    {children}
  </div>
);

NavGroup.defaultProps = {
  label: false,
  children: {},
};

NavGroup.propTypes = {
  label: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  children: PropTypes.instanceOf(Object),
};

function Navigation({ className }) {
  const [activeAccount] = useActiveAccount();
  const userRole = AuthStore.get('_role');

  // if (!activeAccount?.role) {
  //   return (
  //     <div className="text-center text-sm p-4 text-gray-500 italic">
  //       Organization not found.
  //     </div>
  //   );
  // }
  return (
    <nav className={cn('mt-2 px-2 space-y-3', className)}>
      <NavGroup>
        <NavItem to="/dashboard" label="Dashboard" icon={RiDashboardLine} />
        {activeAccount?.role !== 'DEV' ? (
          <NavItem to="/transactions" label="Transactions" icon={BiListUl} />
        ) : null}
        <NavItem to="/settlement" label="Settlements" icon={BiTable} />
        {activeAccount?.role !== 'MERCHANT' ? (
          <NavItem to="/billers/profile" label="Billers" icon={BiStore} />
        ) : null}
        {/* {activeAccount?.role === 'OWNER' ? (
          <NavItem to="/settlement" label="Settlement" icon={BiMoney} />
        ) : null} */}
        {/* {activeAccount?.role === 'OWNER' ? (
          <NavItem to="/invoice" label="Invoice" icon={BiFile} />
        ) : null} */}
        {/* {activeAccount?.role === 'OWNER' ? (
          <NavItem to="/report" label="Reports" icon={BiDownload} />
        ) : null} */}
      </NavGroup>
      {userRole === 'organization' ? (
        <NavGroup label="Settings">
          <NavItem label="Access Control" icon={BiLockOpen} to="/acl/users" />

          {/* <NavItem label="Settings" icon={CgDatabase} to="/profile" /> */}
        </NavGroup>
      ) : null}
    </nav>
  );
}

Navigation.defaultProps = {
  className: '',
};

Navigation.propTypes = {
  className: PropTypes.string,
};

function Sidebar({ sidebarOpen, setSidebarOpen }) {
  const [activeAccount] = useActiveAccount();
  return (
    <>
      <Transition.Root show={sidebarOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 flex z-40 md:hidden"
          open={sidebarOpen}
          onClose={setSidebarOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-600 bg-opacity-75" />
          </Transition.Child>
          <Transition.Child
            as={Fragment}
            enter="transition ease-in-out duration-300 transform"
            enterFrom="-translate-x-full"
            enterTo="translate-x-0"
            leave="transition ease-in-out duration-300 transform"
            leaveFrom="translate-x-0"
            leaveTo="-translate-x-full"
          >
            <div className="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-gradient-to-tr from-primary-700 to-primary-800">
              <Transition.Child
                as={Fragment}
                enter="ease-in-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in-out duration-300"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="absolute top-0 right-0 -mr-12 pt-2">
                  <button
                    className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                    onClick={() => setSidebarOpen(false)}
                    type="button"
                  >
                    <span className="sr-only">Close sidebar</span>
                    <HiOutlineX
                      className="h-6 w-6 text-white"
                      aria-hidden="true"
                    />
                  </button>
                </div>
              </Transition.Child>
              <div className="flex-shrink-0 flex items-center px-4">
                <Link to="/" className="flex relative">
                  <img
                    className="h-16 w-auto"
                    src={activeAccount.logo || logo}
                    alt="Brand"
                  />
                  <p className="absolute bottom-1 left-10 ml-3 text-xs text-white whitespace-nowrap">
                    BILLER PORTAL
                  </p>
                </Link>
              </div>
              <div className="mt-5 flex-1 h-0 overflow-y-auto">
                <Navigation />
              </div>
            </div>
          </Transition.Child>
          <div className="flex-shrink-0 w-14" aria-hidden="true" />
        </Dialog>
      </Transition.Root>

      {/* Static sidebar for desktop */}
      <div className="hidden md:flex md:flex-shrink-0">
        <div className="flex flex-col w-64">
          {/* Sidebar component, swap this element with another sidebar if you like */}
          <div
            className="flex flex-col flex-grow border-r border-gray-200 pt-5 bg-gradient-to-tr from-primary-700 to-primary-800 overflow-y-auto side-nav-wrapper"
            style={{ borderRadius: '0 50px 50px 0' }}
          >
            <div className="flex items-center flex-shrink-0 px-4">
              <Link
                to="/"
                className="flex justify-center items-center relative"
              >
                <SolidLogo className="h-24" />
                <p className="absolute bottom-3 left-16 ml-4 text-xs text-white whitespace-nowrap">
                  BILLER PORTAL
                </p>
              </Link>
            </div>
            <div className="mt-5 flex-grow flex flex-col">
              {/* <AccountSidebarStatus /> */}
              {/* <SidebarProfile /> */}
              {/* <AccountSwitcher /> */}
              <Navigation className="flex-1" />
              {/* bg-gradient-to-tr from-primary-700 to-primary-800 */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

Sidebar.propTypes = {
  sidebarOpen: PropTypes.bool.isRequired,
  setSidebarOpen: PropTypes.func.isRequired,
};

export default Sidebar;
